import storage from "@axel669/json-storage"

window.storage = storage
const store = storage(localStorage, "items")
let data = $state(store.chars ?? [])
$effect.root(() => {
    $effect(
        () => store.chars = data
    )
})

export default {
    get data() { return data },
    set data(value) { return data = value }
}
